import { useQuery, useQueryClient } from '@tanstack/react-query';
import { ProfileApiAdapter } from '../adapters/ProfileApiAdapter';
import { Profile } from '../models/Profile';
import { apiClientWH } from '@shared/services';
import { createHttpClient } from '@adapters/HttpClient';

const httpClient = createHttpClient(apiClientWH);
const adapter = new ProfileApiAdapter(httpClient);

export const useProfile = () => {
  const queryClient = useQueryClient();

  const query = useQuery<Profile>({
    queryKey: ['profile'],
    queryFn: () => adapter.getCurrentUserProfile(),
    staleTime: 2 * 60 * 1000, // 2 minutos
  });

  const updateUser = async (payload: any) => {
    await adapter.updateUser(payload);
    // ✅ invalidar cache para que cualquier componente recargue el nuevo perfil
    await queryClient.invalidateQueries({ queryKey: ['profile'] });
  };

  return {
    ...query,
    updateUser,
  };
};
